import { render, staticRenderFns } from "./reset-stock.vue?vue&type=template&id=12065075&scoped=true"
import script from "./reset-stock.vue?vue&type=script&lang=js"
export * from "./reset-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12065075",
  null
  
)

export default component.exports